/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
    header ハンバーガーメニュー
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
(() => {
  const button = document.getElementById('hamburger-button');
  const drawer = document.getElementById('nav-drawer');
  if (!button || !drawer) return;

  const toggleDrawer = () => {
    document.documentElement.classList.toggle('is-drawerActive');

    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
  };

  button.addEventListener('click', toggleDrawer);

  drawer.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    toggleDrawer();
  });
})();

/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
  header toggle
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
(() => {
  const WRAP_SELECTOR = '.js-accordionWrap';
  const PANEL_SELECTOR = '.js-accordion';
  const ACTIVE_CLASS = 'is-open';
  const CLOSE_DELAY = 200;
  const SLIDE_MS = 240;
  const MQ = window.matchMedia('(max-width: 1200px)');
  const wraps = Array.from(document.querySelectorAll(WRAP_SELECTOR));
  if (!wraps.length) return;
  const isMobile = () => MQ.matches;
  const getPanel = (wrap) =>
    wrap.querySelector(`:scope > ${PANEL_SELECTOR}`) || wrap.querySelector(PANEL_SELECTOR);
  const clearCloseTimer = (wrap) => {
    if (wrap._closeTimer) {
      clearTimeout(wrap._closeTimer);
      wrap._closeTimer = null;
    }
  };

  const closeAllDesktop = (exceptWrap = null) => {
    wraps.forEach((w) => {
      if (w === exceptWrap) return;
      w.classList.remove(ACTIVE_CLASS);
      clearCloseTimer(w);
    });
  };

  const openDesktop = (wrap) => {
    clearCloseTimer(wrap);
    closeAllDesktop(wrap);
    wrap.classList.add(ACTIVE_CLASS);
  };

  const scheduleCloseDesktop = (wrap) => {
    clearCloseTimer(wrap);
    wrap._closeTimer = setTimeout(() => {
      wrap.classList.remove(ACTIVE_CLASS);
    }, CLOSE_DELAY);
  };

  const setHeight = (panel, px) => {
    /*panel.style.height = `${px}px`;*/
    panel.style.height = `auto`;
  };

  const onHeightTransitionEndOnce = (panel, callback) => {
    const handler = (e) => {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', handler);
      callback();
    };
    panel.addEventListener('transitionend', handler);
  };

  const closeMobile = (wrap) => {
    const panel = getPanel(wrap);
    if (!panel) return;
    if (!wrap.classList.contains(ACTIVE_CLASS)) return;

    const current = panel.getBoundingClientRect().height;
    setHeight(panel, current);

    requestAnimationFrame(() => {
      setHeight(panel, 0);
      onHeightTransitionEndOnce(panel, () => {
        wrap.classList.remove(ACTIVE_CLASS);
        panel.style.height = '';
      });
    });
  };

  const closeAllMobile = (exceptWrap = null) => {
    wraps.forEach((w) => {
      if (w === exceptWrap) return;
      closeMobile(w);
    });
  };

  const openMobile = (wrap) => {
    const panel = getPanel(wrap);
    if (!panel) return;
    closeAllMobile(wrap);
    wrap.classList.add(ACTIVE_CLASS);
    setHeight(panel, 0);
    requestAnimationFrame(() => {
      const target = panel.scrollHeight;
      setHeight(panel, target);

      onHeightTransitionEndOnce(panel, () => {
        panel.style.height = 'auto';
      });
    });
  };


  const toggleMobile = (wrap) => {
    if (wrap.classList.contains(ACTIVE_CLASS)) {
      closeMobile(wrap);
    } else {
      openMobile(wrap);
    }
  };

  wraps.forEach((wrap) => {
    const panel = getPanel(wrap);
    if (!panel) return;

    // PC: hoverでフェード
    wrap.addEventListener('pointerenter', () => {
      if (isMobile()) return;
      openDesktop(wrap);
    });

    wrap.addEventListener('pointerleave', () => {
      if (isMobile()) return;
      scheduleCloseDesktop(wrap);
    });

    wrap.addEventListener('focusin', () => {
      if (isMobile()) return;
      openDesktop(wrap);
    });

    wrap.addEventListener('focusout', (e) => {
      if (isMobile()) return;
      if (!wrap.contains(e.relatedTarget)) scheduleCloseDesktop(wrap);
    });

    // SP: クリックでスライド開閉
    wrap.addEventListener('click', (e) => {
      if (!isMobile()) return;
      if (e.target.closest(PANEL_SELECTOR)) return;
      e.preventDefault();
      toggleMobile(wrap);
    });
  });

  document.addEventListener('pointerdown', (e) => {
    if (e.target.closest(WRAP_SELECTOR)) return;
    if (isMobile()) {
      closeAllMobile();
    } else {
      closeAllDesktop();
    }
  });

  const resetOnBreakpoint = () => {
    wraps.forEach((wrap) => {
      clearCloseTimer(wrap);
      const panel = getPanel(wrap);
      if (panel) panel.style.height = '';
    });
    wraps.forEach((w) => w.classList.remove(ACTIVE_CLASS));
  };

  if (MQ.addEventListener) {
    MQ.addEventListener('change', resetOnBreakpoint);
  } else if (MQ.addListener) {
    MQ.addListener(resetOnBreakpoint);
  }
})();


/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
  header scroll クラス付与
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
(() => {
  const header = document.querySelector('.l-header');
  if (!header) return;

  const mq = window.matchMedia('(min-width: 1201px)');
  let isEnabled = false;
  let ticking = false;

  const update = () => {
    header.classList.toggle('js-scroll', window.scrollY > 0);
    ticking = false;
  };

  const onScroll = () => {
    if (!isEnabled) return;
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const enable = () => {
    if (isEnabled) return;
    isEnabled = true;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const disable = () => {
    if (!isEnabled) return;
    isEnabled = false;
    window.removeEventListener('scroll', onScroll);
    header.classList.remove('js-scroll');
    ticking = false;
  };

  const handleChange = () => {
    if (mq.matches) enable();
    else disable();
  };

  // 初期判定
  handleChange();

  // ブレイクポイント跨ぎ対応
  if (mq.addEventListener) mq.addEventListener('change', handleChange);
  else mq.addListener(handleChange);
})();


/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
  viewport
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
const viewport = document.querySelector('meta[name="viewport"]');
function switchViewport() {
  if (!viewport) return;

  const value = window.outerWidth > 360
    ? 'width=device-width,initial-scale=1'
    : 'width=360';

  if (viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}
window.addEventListener('resize', switchViewport);
switchViewport();

/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
  br
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
document.querySelectorAll('br').forEach(br => {
  br.setAttribute('aria-hidden', 'true');
});

/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
  Search Overlay (PXU / Shopify recurrent)
  - スクロールバーは消さない（overflow を触らない）
  - オーバーレイ表示/非表示のみ制御
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
(() => {
  const overlay = document.getElementById('pxu-searchOverlay');
  if (!overlay) return;

  const openButtons = Array.from(document.querySelectorAll('.js-search-open'));
  const closeButtons = Array.from(overlay.querySelectorAll('[data-search-close]'));
  const input = overlay.querySelector('.pxu-searchOverlay__input');

  let lastActive = null;

  const onKeydown = (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (overlay.classList.contains('is-open')) {
        e.preventDefault();
        closeOverlay();
      }
    }
  };

  function setExpanded(value) {
    openButtons.forEach((btn) => btn.setAttribute('aria-expanded', value ? 'true' : 'false'));
  }

  function openOverlay(trigger) {
    lastActive = trigger || document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    setExpanded(true);

    // 背面のスクロールバーは残す。操作だけ止めたい場合は backdrop クリックで閉じる運用にする
    if (input) {
      setTimeout(() => {
        try { input.focus(); } catch(e) {}
      }, 0);
    }
    document.addEventListener('keydown', onKeydown);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    setExpanded(false);
    document.removeEventListener('keydown', onKeydown);

    if (lastActive && typeof lastActive.focus === 'function') {
      try { lastActive.focus(); } catch(e) {}
    }
  }

  openButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      // a 要素でも button 要素でも動くように
      e.preventDefault();
      openOverlay(btn);
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeOverlay();
    });
  });

  // パネル内クリックで閉じない
  const panel = overlay.querySelector('.pxu-searchOverlay__panel');
  if (panel) {
    panel.addEventListener('click', (e) => e.stopPropagation());
  }
})();

/*＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
水色の帯footer上で固定解除
＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝*/
document.addEventListener('DOMContentLoaded', function () {
    const archiveWrap = document.querySelector('.f_archiveWrap');
    const footer = document.querySelector('footer');

    if (!archiveWrap) return; // .f_archiveWrapがないページは何もしない

    const archiveHeight = archiveWrap.offsetHeight;

    // footerのmargin-topを調整
    const currentMargin = parseFloat(getComputedStyle(footer).marginTop);
    footer.style.marginTop = `calc(${currentMargin}px + ${archiveHeight}px)`;

    function updatePosition() {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (footerRect.top <= windowHeight) {
            const overlap = windowHeight - footerRect.top;
            archiveWrap.style.bottom = overlap + 'px';
        } else {
            archiveWrap.style.bottom = '0px';
        }
    }

    window.addEventListener('scroll', updatePosition);
    updatePosition();
});